export enum PaymentStatusEnum {
  INITIALIZED = 'INITIALIZED',
  PENDING = 'PENDING',
  PAID = 'PAID',
  FAILED = 'FAILED',
  RECOVERED = 'RECOVERED',
  DRAFT = 'DRAFT',
  AWAITING = 'AWAITING'
}
